import React from 'react';
import { FormControl, FormLabel, Select, Tooltip } from '@chakra-ui/react';

export const ProfileSelect = ({ state, setter, name, options, ru, en, ...props }) => {
	const onChange = e => setter({ ...state, [e.target.name]: e.target.value });
	const tooltip = { label: ru, placement: 'top-start' };

	return (
		<FormControl {...props}>
			<Tooltip {...tooltip}>
				<FormLabel>{en}</FormLabel>
			</Tooltip>
			<Select {...{ name, onChange }}>
				{Object.keys(options).map(key => (
					<option key={key} value={key} selected={key === state[name]}>
						{options[key]}
					</option>
				))}
			</Select>
		</FormControl>
	);
};
